module.exports = __webpack_public_path__ + "static/media/Paladin_Holy.00036e07.png";